import { trueFalseToBoolean, hasProperty, loadUserSessionStorage, valueExist, tryGetNodeAlt } from "../utils/helpers.utils";
import { httpPost, httpGet, setAuthToken } from "../utils/api.utils";
import { NODE_ENVIRONMENTS as nodeEnv, CONFIG as config, EXCLUDE_SELECT_CLIENT_FOR_ROLE_ID, LOGIN_STATUS } from "../utils/constant.utils";
import { LOGIN_TYPE } from "../utils/rbac-constants.utils";
import { UserManager } from "../utils";
import { USER_ROLES_ID } from "../constants/external-constants";
import {
    getClientScopes
    , getUserScope
    , login
    , logout
    , onSelectClientScope
    , setAuthedUser
    , setLoginStatus
    , setUiTODetails
    , showDataPrivacy
    , submitLoginForm
    , setUserRoutes
} from "./../constants/user-login.settings";
import NotificationHubConnector from './../utils/signalr-connection';

const initialState = {
        ssoEnabled: trueFalseToBoolean(process.env.REACT_APP_AAD_AUTH_ENABLE),
        loginDetails: [],
        hasUserScope: false,
        clientScopes: [],
        clientScopeSelected: null,
        clientSelectionEnabled: false,
        loginStatus: null,
        isLoggedIn: false,
        user: loadUserSessionStorage() !== undefined ? loadUserSessionStorage() : {},
        //isLoggingIn: trueFalseToBoolean(process.env.REACT_APP_EXTERNAL_REDIRECTION) || trueFalseToBoolean(process.env.REACT_APP_AAD_AUTH_ENABLE),
        isLoggingIn: false,
        isLoggingOut: false,
        isLoginError: false,
        uiTimeOutDetails: config.timeoutDetails,
        //data privacy
        isFetching: true,
        showModal: false,
        modalProps: {},
        message: null,
        userRoutes: []
};

export const loginActions = {
    logout: () => async (dispatch) => {
        const { closeConnection } = NotificationHubConnector();
        dispatch({
            type: logout,
            isLoggedIn: false,
            isLoggingOut: true,
        });
        if (trueFalseToBoolean(process.env.REACT_APP_AAD_AUTH_ENABLE) && process.env.NODE_ENV !== nodeEnv.dev) {
            await httpPost('external/login/logoutExternal')
            UserManager.clearStaleState();
            UserManager.removeUser();
            UserManager.signoutRedirect();
        } 
        sessionStorage.clear();
        localStorage.clear();
        closeConnection();
        if (!trueFalseToBoolean(process.env.REACT_APP_AAD_AUTH_ENABLE)) {
            window.location.href = "/"; //this line of code only needs to run if ATEM app is NOT using SSO login
        } 
    },
    submitCrendentials: (userName, password) => async(dispatch, state) => {
        var ssoEnabled = trueFalseToBoolean(process.env.REACT_APP_AAD_AUTH_ENABLE);
        var data = {
            IsAzureEnabled: ssoEnabled,
            AzureAccessToken: userName.trim(),
            ...(!ssoEnabled) && { Email: userName.trim() },
            ...(!ssoEnabled) && { Password: password.trim() }
        }

        var isSuccess = false;

        if (!ssoEnabled) {
            var encryptedPassword = await httpGet(`common/auth/encrypt?text=${password}`);

            window.localStorage.setItem("atemusername", userName);
            window.localStorage.setItem("atempassword", encryptedPassword.data);
        }

        dispatch({type:submitLoginForm, data:data});
        var userScope = await httpPost('common/auth/getUserScope', data);
        if (!userScope.IsUserActive && userScope.IsUserActive !== undefined) {
            window.location.href = '/invalidaccess';
            dispatch({
                hasUserScope: false
            });
        }
        if (ssoEnabled) {
            if (userScope.statusText === 'Unauthorized' || parseInt(userScope.status) === 500) {
                window.location.href = '/invalidaccess';
                dispatch({
                    hasUserScope: false
                });
            }
        }
        if (userScope.RoleId == USER_ROLES_ID.noAccess) {
            window.location.href = '/invalidaccess';
            dispatch({
                hasUserScope: false
            });
        }
        else if (userScope.ok === undefined) {
            sessionStorage.setItem('DealName', userScope.DealName);
            sessionStorage.setItem('DealId', userScope.DealId);

            localStorage.setItem('DealName', userScope.DealName);
            localStorage.setItem('DealId', userScope.DealId);

            sessionStorage.setItem('UserRoleID', userScope ? userScope.RoleId : '');

            dispatch({type: getUserScope, 
                data: Object.keys(userScope).length > 1
            });
            isSuccess = true;
        }

        return isSuccess;
    },
    onSelectClientScope: (e) => (dispatch, state) => {
        var id = e.target.options.selectedIndex;
        var value = e.target.value;
        sessionStorage.setItem('DealName', value);
        sessionStorage.setItem('DealId', id);

        localStorage.setItem('DealName', value);
        localStorage.setItem('DealId', id);

        dispatch(
            {   
                type:onSelectClientScope, 
                data: value,
                clientSelectionEnabled: value !== null
            });
    },
    loginSelection: (status) => async (dispatch, state) => {    
        sessionStorage.setItem("logInStatus", status);
        localStorage.setItem("logInStatus", status);
        dispatch({type:setLoginStatus, data: status});
    },

    login: (status) => async (dispatch, state) => {
        const {oidc, authentication} = state();
        const { ssoEnabled, loginDetails } = authentication;
        const { user } = oidc;
        var data = loginDetails;

        sessionStorage.setItem("logInStatus", status);
        localStorage.setItem("logInStatus", status);
        dispatch({ type: setLoginStatus, data: status });

        dispatch({
            type: login,
            isLoggedIn: false,
            isLoggingIn: true
        })
        var response = await httpPost('external/login', data);
        if ((response.Response === true || response.ok === true) && response.Employee != null) {
            var token = ssoEnabled ? user.access_token : response.Token;
            var userResult = JSON.stringify(response)
            setAuthToken(token);

            setUserSession(token, ssoEnabled, response);

            dispatch({
                type: setAuthedUser,
                userInfo: userResult,
            });
            dispatch({
                type: login,
                isLoggedIn: true,
                isLoggingIn: false,
                isLoginError: false,
            });
        }
        else{
            dispatch({
                type: login,
                isLoggedIn: false,
                isLoggingIn: false,
                isLoginError: true
            });
          window.location.href = '/invalidaccess';
        } 
    },
    setUser: (userInfo) => (dispatch, getState) => {
        dispatch({
            type: setAuthedUser,
            userInfo: userInfo,
        });
    },
    setUIIdleTime: () => async (dispatch) => {
        let uiTimeOutDetails = config.timeoutDetails
        const t = await httpGet('common/auth/getUITimeoutDetails');
        if (hasProperty(t, 'IdleWarningNotif')) {
            uiTimeOutDetails = {
                idleWarningNotif: t.IdleWarningNotif,
                idleDuration: t.IdleDuration
            }
            dispatch({
                type: setUiTODetails,
                uiTimeOutDetails: uiTimeOutDetails
            });
        }
    },
    newUser: () => async (dispatch, state) => {
        var legalDisclaimer = {
            id: "legal-disclaimer",
        }
        var userId = JSON.parse(sessionStorage.getItem('User'))?.Employee.UserId;
        var data = await httpGet("external/dataPrivacy/isNewUser/" + userId);
        var isNewUser = data !== null && data !== false;
        sessionStorage.NewUser = isNewUser ? 'true' : 'false';
        if (isNewUser) {
            dispatch({
                type: showDataPrivacy,
                showModal: true,
                modalProps: legalDisclaimer,
                message: data[0].Value,
            })
        }
    },
    handleAccept: () => async (dispatch, state) => {
        var userId = JSON.parse(sessionStorage.getItem('User')).Employee.UserId;
        var newUser = await httpPost('external/dataPrivacy/acceptDataPrivacy?userid=' + userId)
        var isNewUser = newUser == 1;
        if (isNewUser) {
            sessionStorage.NewUser = isNewUser ? 'false' : 'true';
            dispatch({
                type: showDataPrivacy,
                showModal: false,
                modalProps: {id : ''},
            })
        }
    },
    getUserRoutes: () => async (dispatch, state) => {
        await getUserRoutes(dispatch);
    },
    getUserAuth: () => async (dispatch, state) => {
        try {
            var token = localStorage.getItem('access_token');
            var dealName = localStorage.getItem('DealName');
            var dealId = localStorage.getItem('DealId');
            var logInStatus = localStorage.getItem('logInStatus');

            if (sessionStorage.getItem('access_token') === null
                && token !== null
                && dealName !== null
                && dealId !== null
                && logInStatus !== null) {
                var ssoEnabled = trueFalseToBoolean(process.env.REACT_APP_AAD_AUTH_ENABLE);
                setAuthToken(token);

                var response = await httpGet('common/auth/getUserAuth');

                var userResult = JSON.stringify(response)

                setUserSession(token, ssoEnabled, response);

                sessionStorage.setItem("DealName", dealName);
                sessionStorage.setItem("DealId", dealId);
                sessionStorage.setItem("logInStatus", LOGIN_STATUS.external);

                dispatch({
                    type: setAuthedUser,
                    userInfo: userResult,
                });
                dispatch({
                    type: login,
                    isLoggedIn: true,
                    isLoggingIn: false,
                    isLoginError: false,
                });
            }
            else if (sessionStorage.getItem('access_token') !== null
                && token === null
                && dealName === null
                && dealId === null
                && logInStatus === null) {
                localStorage.clear();
                sessionStorage.clear();
            }
        }
        catch (e) {
            localStorage.clear();
            sessionStorage.clear();
            window.location.href = '/userlogin';
        }
    }
}

async function getUserRoutes(dispatch) {
    var res = await httpGet('common/auth/getUserRoutes?loginTypeId=' + LOGIN_TYPE.External);

    if (res != null) {
        dispatch({ type: setUserRoutes, data: res });
    } else {
        dispatch({ type: setUserRoutes, data: [] });
    }
}

function setUserSession(token, ssoEnabled, response) {
    var userResult = JSON.stringify(response);

    sessionStorage.setItem('access_token', token);
    sessionStorage.setItem('UserID', response.Employee ? response.Employee.UserId : '');
    sessionStorage.setItem('EID', response.Employee ? response.Employee.EnterpriseId : '');
    sessionStorage.setItem('FirstName', response.Employee ? response.Employee.FirstName : '');
    sessionStorage.setItem('MiddleInitial', response.Employee ? response.Employee.MiddleInitial : '');
    sessionStorage.setItem('LastName', response.Employee ? response.Employee.LastName : '');
    sessionStorage.setItem('IsExecutive', response.Employee ? response.Employee.IsExecutive : '');
    sessionStorage.setItem('UserRoleID', response.Employee.Role ? response.Employee.Role.RoleId : '');
    sessionStorage.setItem('RoleName', response.Employee.Role ? response.Employee.Role.RoleName : '');
    sessionStorage.setItem('RolePermissionId', response.Employee.RolePermission ? response.Employee.RolePermission.RoleId : '');
    sessionStorage.setItem('RolePermissionName', response.Employee.RolePermission ? response.Employee.RolePermission.RoleName : '');
    sessionStorage.setItem('RolePermissionCode', response.Employee.RolePermission ? response.Employee.RolePermission.RoleCode : '');
    sessionStorage.setItem('NewUser', response.Employee.NewUser);
    sessionStorage.setItem('EmployeeID', response.Employee ? response.Employee.EmployeeId : '');
    sessionStorage.setItem('IsKeyUser', response.Employee.IsKeyUser);
    sessionStorage.setItem('IsRSO', response.Employee.IsRSO);
    sessionStorage.setItem('IsCSM', response.Employee.IsCSM);
    sessionStorage.setItem('ManagerApproverID', response.Employee.Manager ? response.Employee.Manager.EmployeeId : '');
    sessionStorage.setItem('Vip', response.Employee.Vip);
    sessionStorage.setItem('IsWireLineApprover', response.Employee.IsWireLineApprover);
    sessionStorage.setItem('CostCodeAuthorizerID', tryGetNodeAlt(response.Employee, '', 'CostCodeAuthorizer.EmployeeId'))
    sessionStorage.setItem('IsCostCodeAuthorizer', response.Employee.IsCostCodeAuthorizer);
    sessionStorage.setItem('CostCodeId', response.Employee ? response.Employee.CostCodeId : '');
    sessionStorage.setItem('Idhr', response.Employee ? response.Employee.IdHr : '');
    sessionStorage.setItem('User', userResult);
    sessionStorage.setItem('IsAzureEnabled', ssoEnabled);
    sessionStorage.setItem('IsEnabledQuotationRequest', response.Employee ? response.Employee.IsEnabledQuotationRequest : '');
    sessionStorage.setItem('IsEnabledCallTagging', response.Employee ? response.Employee.IsEnabledCallTagging : '');
    sessionStorage.setItem('IsEnabledOrderEmail', response.Employee ? response.Employee.IsEnabledOrderEmail : '');
    sessionStorage.setItem("AccessModuleMatrix", JSON.stringify(response.Employee.AccessMatrixDetails));
    sessionStorage.setItem('IsHRLineManager', response.Employee.IsHRLineManager);
    sessionStorage.setItem('IsEnabledWirelineTab', response.Employee ? response.Employee.IsEnabledWirelineTab : '');

    localStorage.setItem('access_token', token);
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case submitLoginForm:
            return{
                ...state,
                loginDetails: action.data
            }
        case getUserScope:
            return{
                ...state,
                hasUserScope: action.data
            }
        case getClientScopes:
            return{
                ...state,
                clientScopes: action.data
            }
        case setLoginStatus:
            return{
                ...state,
                loginStatus: action.data
            };
        case onSelectClientScope:
            return{
                ...state,
                clientScopeSelected: action.data,
                clientSelectionEnabled: action.clientSelectionEnabled
            };
        case logout:
            return {
                ...state,
                isLoggedIn: action.isLoggedIn,
                isLoggingOut: action.isLoggingOut,
            }
        case login:
            return {
                ...state,
                isLoggedIn: action.isLoggedIn,
                isLoggingIn: action.isLoggingIn,
                isLoginError: action.isLoginError
            };
        case setAuthedUser:
            return {
                ...state,
                user: action.userInfo
            };
        case setUiTODetails:
            return {
                ...state,
                uiTimeOutDetails: action.uiTimeOutDetails
            };
        case showDataPrivacy:
            return {
                ...state,
                showModal: action.showModal,
                modalProps: action.modalProps,
                message: action.message,
            };
        case setUserRoutes:
            return {
                ...state,
                userRoutes: action.data
            };
        default:
            return state;
    }
}